export default __webpack_public_path__ + "static/media/Raionfull.b30cbcaf.png";